var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-toggle-button',{staticClass:"rtlswitch",attrs:{"label":_vm.label},model:{value:(_vm.rtlDirOn),callback:function ($$v) {_vm.rtlDirOn=$$v},expression:"rtlDirOn"}})}
var staticRenderFns = []

export { render, staticRenderFns }